import { useState, useEffect } from 'react';

import { storageLocal } from 'utils/storageLocal';

import type { StorageLocal } from 'utils/storageLocal';

/**
 * webストレージを操作するカスタムフック
 */
export const useStorage = (
  key: string,
  initial: string = '',
  storageType: 'local' | 'session' = 'session',
) => {
  const [storage, setStorage] = useState<StorageLocal>();
  const [value, setValue] = useState<string | null>(null);

  useEffect(() => {
    const storageInstance = storageLocal(key, initial, storageType);
    setStorage(storageInstance);
    setValue(storageInstance.read());
  }, [key, initial, storageType]);

  const write = (newValue: string) => {
    if (storage) {
      storage.write(newValue);
      setValue(newValue);
    }
  };

  return { value, write };
};
